// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__htPa_","header":"PatientBlock_header__jALw-","label":"PatientBlock_label__2o12S","option":"PatientBlock_option__6VWDW"};